import { Args, newsInstance } from "./client";

const imageUpload = <T>(args: Args) => {
  return newsInstance<T>({
    data: args.data,
    method: args.method,
    url: args.url,
  });
};

export { imageUpload };
